export const 
SET_HELP_MENU_ACTIVE_KEY = 'SET_HELP_MENU_ACTIVE_KEY',
TOGGLE_HELP_MENU = 'TOGGLE_HELP_MENU',
TOGGLE_HELP_FAQ_MODAL = 'TOGGLE_HELP_FAQ_MODAL';
